import { Column, Entity, PrimaryGeneratedColumn } from "typeorm";

@Entity("ability_types")
export class AbilityType {
  @PrimaryGeneratedColumn({ type: "int", name: "id" })
  id: number;

  @Column("int", { name: "ability_id" })
  abilityId: number;

  @Column("varchar", { name: "types", length: 255, nullable: true })
  types: string | null;

  @Column("tinyint", { name: "status", default: () => '1' })
  status: number;
}
